export { default } from './ServicesOfferPriceAndInstallments';